import { CalendarDays, Clock, CloudSun, ListChecks, MapPin, Newspaper, type LucideIcon } from 'lucide-react';

/** The widgets, each with its own settings page under Settings → Widgets. */
export type WidgetPageId = 'clock' | 'location' | 'weather' | 'calendar' | 'lists' | 'news';

/** Where each widget's settings live (all have `enabled`). */
export type WidgetKey = 'clock' | 'photoInfo' | 'weather' | 'calendar' | 'lists' | 'news';

export const WIDGET_PAGES: Array<{ id: WidgetPageId; name: string; icon: LucideIcon; key: WidgetKey }> = [
  { id: 'clock', name: 'Clock', icon: Clock, key: 'clock' },
  // The key stays 'photoInfo' so settings saved before it became the Location widget carry over.
  { id: 'location', name: 'Location', icon: MapPin, key: 'photoInfo' },
  { id: 'weather', name: 'Weather', icon: CloudSun, key: 'weather' },
  { id: 'calendar', name: 'Calendar', icon: CalendarDays, key: 'calendar' },
  { id: 'lists', name: 'To-do lists', icon: ListChecks, key: 'lists' },
  { id: 'news', name: 'News', icon: Newspaper, key: 'news' },
];
